import clientApi from "@/services/byLawViewerAPI";

export default {
    fetchAllParts: async ({ commit, state }) => {
        if(state.serviceUnavailable) return;
        try {
            await clientApi.getPartsByDocument()
            .then(response => { 
                if (response.status == 200) {
                    if(response.data.count == 0){
                        commit("byLawFetchFailed", null);
                    } else{
                        commit("loadByLawParts", response.data);
                    }
                    
                } else {
                    commit("byLawFetchFailed", null);
                }
            })
            .catch(error => {
                commit("byLawFetchFailed", null)
                console.log(error);
            });
        } catch (error) {
            commit("byLawFetchFailed", null);
        }
    },
    fetchPusblishedContentByPart: async ({ commit, state }, partId) => {
       
        let partInStorage = state.documents.parts.filter(part => part.id === partId);
        let dataAlreadyExists = partInStorage.children?.length > 0;

        if(!dataAlreadyExists){
            try {
                await clientApi.getContentsByPart(partId)
                .then(response => { 
                    if (response.status == 200) {
                        commit("loadByLawContentForPart", response.data);
                    } else {
                        commit("byLawContentFetchFailed", null);
                    }
                })
                .catch(error => {
                    commit("byLawContentFetchFailed", null)
                    console.log(error);
                });
            } catch (error) {
                commit("byLawContentFetchFailed", null);
            }
        }
    },
    fetchDocument: async ({ commit, state }) => {
               
        try {
            await clientApi.getDocument()
            .then(response => { 
                if (response.status == 200) {
                    if(response.data.id == 0){
                        commit("documentNotFound", null);
                    } 
                    else {
                        commit("documentFound", response.data);     
                    }
                    
                } else {
                    commit("documentNotFound", null);
                }
            })
            .catch(error => {
                commit("documentNotFound", null)
                console.log(error);
            });
        } catch (error) {
            commit("NetworkError", null);
        }
    },
    fetchSharePathForVersion: async ({ commit, state }, version) => {
              
        try {
            await clientApi.getSharingPathForVersion(version)
            .then(response => { 
                if (response.status == 200) {
                    commit("setSharePath", response.data);
                } else {
                    commit("setShareQueryError", null);
                }
            })
            .catch(error => {
                commit("setShareQueryError", null)
                console.log(error);
            });
        } catch (error) {
            commit("NetworkError", null);
        }
    },
    fetchSharePathForDefinition: async ({ commit, state }, definition) => {
               
        try {
            await clientApi.getSharingPathForDefinition(definition)
            .then(response => { 
                if (response.status == 200) {
                    commit("setSharePath", response.data);
                } else {
                    commit("setShareQueryError", null);
                }
            })
            .catch(error => {
                commit("setShareQueryError", null)
                console.log(error);
            });
        } catch (error) {
            commit("NetworkError", null);
        }
    },
    fetchSharePathForTag: async ({ commit, state }, tag) => {
         
        try {
            await clientApi.getSharingPathForTag(tag)
            .then(response => { 
                if (response.status == 200) {
                    commit("setSharePath", response.data);
                } else {
                    commit("setShareQueryError", null);
                }
            })
            .catch(error => {
                commit("setShareQueryError", null)
                console.log(error);
            });
        } catch (error) {
            commit("NetworkError");
        }
    },
    fetchDefinitions: async ({ commit, state }) => {
        if(state.serviceUnavailable) return;
           
        try {
            await clientApi.getDefitition()
            .then(response => { 
                if (response.status == 200) {
                    commit("definitionFetched", response.data);
                } else {
                    commit("DefinitionsNotFound");
                }
            })
            .catch(error => {
                commit("DefinitionsNotFound")
                console.log(error);
            });
        } catch (error) {
            commit("NetworkError");
        }
    }
};
